import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Plane, Home, UtensilsCrossed, Anchor } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Plane,
      title: t('services.items.vip.title'),
      description: t('services.items.vip.description'),
      image: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: Home,
      title: t('services.items.villa.title'),
      description: t('services.items.villa.description'),
      image: 'https://images.unsplash.com/photo-1582610116397-edb318620f90?auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: UtensilsCrossed,
      title: t('services.items.chef.title'),
      description: t('services.items.chef.description'),
      image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: Anchor,
      title: t('services.items.yacht.title'),
      description: t('services.items.yacht.description'),
      image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <section id="services" className="section-padding bg-[#FDFCFA]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('services.overline')}</p>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-[#1A1A2E] font-semibold mb-6">
            {t('services.title')}
          </h2>
          <p className="text-[#4A4A5A] max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group card-light rounded-2xl overflow-hidden transition-all duration-500"
              data-testid={`service-card-${index}`}
            >
              <div className="flex flex-col sm:flex-row">
                {/* Image */}
                <div className="relative w-full sm:w-2/5 h-48 sm:h-auto min-h-[200px] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>

                {/* Content */}
                <div className="flex-1 p-6 flex flex-col justify-center">
                  <div className="w-12 h-12 rounded-xl icon-gold flex items-center justify-center mb-4 transition-all">
                    <service.icon className="w-5 h-5 text-[#C9A227]" />
                  </div>
                  
                  <h3 className="text-xl font-playfair text-[#1A1A2E] font-semibold mb-3 group-hover:text-[#C9A227] transition-colors">
                    {service.title}
                  </h3>
                  
                  <p className="text-[#4A4A5A] text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
